import React from 'react';
import { Icon } from 'shared/components';

const SortDirectionIcon = ({ direction }) => (
  <Choose>
    <When condition={ direction === 'ASC' }>
      <Icon name="arrow-up" />
    </When>
    <When condition={ direction === 'DESC' }>
      <Icon name="arrow-down" />
    </When>
    <Otherwise>
      <Icon name="arrows-up-down" />
    </Otherwise>
  </Choose>
);

export default SortDirectionIcon;
